export const SAVE_USER_ROLE_START = 'SAVE_USER_ROLE_START';
export const SAVE_USER_ROLE_SUCCESS = 'SAVE_USER_ROLE_SUCCESS';

export const CREATE_LI_DOCS_CONFIGS_START = 'CREATE_LI_DOCS_CONFIGS_START';
export const CREATE_LI_DOCS_CONFIGS_SUCCESS = 'CREATE_LI_DOCS_CONFIGS_SUCCESS';
export const CREATE_LI_DOCS_CONFIGS_ERROR = 'CREATE_LI_DOCS_CONFIGS_ERROR';

export const UPDATE_LI_DOCS_CONFIGS_START = 'UPDATE_LI_DOCS_CONFIGS_START';
export const UPDATE_LI_DOCS_CONFIGS_SUCCESS = 'UPDATE_LI_DOCS_CONFIGS_SUCCESS';
export const UPDATE_LI_DOCS_CONFIGS_ERROR = 'UPDATE_LI_DOCS_CONFIGS_ERROR';